// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#4e5969",
	"menuActiveText": "#00a551",
	"subMenuActiveText": "#00a551",
	"menuBg": "#fff",
	"menuHover": "#f2fbf6",
	"subMenuBg": "#fff",
	"subMenuHover": "#f2fbf6",
	"sideBarWidth": "260px",
	"sideBarCollapseWidth": "68px",
	"layoutHeaderHeight": "60px",
	"layoutTagsHeight": "40px",
	"layoutHeaderTotalHeight": "100px",
	"brandPrimary": "#00a551",
	"brandPrimaryHover": "#12b866",
	"brandPrimaryActive": "#008f47",
	"brandPrimaryLight": "#e8f8ef",
	"brandPrimarySoft": "#f2fbf6",
	"bgLayout": "#f7f8fa",
	"borderBase": "#e5e6eb",
	"textPrimary": "#1d2129",
	"textRegular": "#4e5969",
	"textSecondary": "#86909c"
};
module.exports = exports;
